import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class InstrumentApiService {
  constructor(private REQ: RequestService) {}

  getInstrumentList(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.INSTRUMENT,
        sub_authority: subAuthorities.INSTRUMENT.LIST,
        operation: operations.LIST,
        data: 'NA',
      },
    };
    return this.REQ.get('instrument/list', { query: JSON.stringify(qry) });
  }
}
